import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { checkboxClasses, formControlLabelClasses, InputLabel } from '@mui/material';
import { archerConstants } from '../../utils/themeProvider.js';
import { customArcherColors } from '../../utils/customArcherColors.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';
import { ListItem } from '../ListItem/ListItem.js';
import { Collapse } from '../Collapse/Collapse.js';
import { Icon } from '../Icon/Icon.js';
import { List } from '../List/List.js';
import { ListItemText } from '../ListItemText/ListItemText.js';
import { Typography } from '../Typography/Typography.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { IconButton } from '../IconButton/IconButton.js';
import { _DeprecatedCheckbox } from '../_DeprecatedCheckbox/_deprecated_Checkbox.js';

var _cascadeListItem;

var styles = {
  listWithChildren: {
    display: 'flex',
    flexDirection: 'row',
    paddingY: 0,
    paddingLeft: 2,
    paddingRight: 0,
    width: '100%',
    '& :first-child': {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  listItemRoot: {
    padding: 0,
    '&.Mui-selected': {
      backgroundColor: 'transparent'
    },
    '&:focus': {
      backgroundColor: archerConstants.archerHover
    }
  },
  listItemRootLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: 0,
    padding: 0,
    '& :first-child': {
      paddingTop: 0,
      paddingBottom: 0,
      '&.Mui-focusVisible': {
        backgroundColor: archerConstants.archerHover,
        borderRadius: '0'
      }
    },
    '& svg': {
      fontSize: '1.25rem'
    },
    width: '100%'
  },
  childListItemExpander: {
    padding: 0,
    width: 'auto'
  },
  recursiveChildList: {
    paddingY: 0,
    paddingLeft: 2,
    paddingRight: 0
  },
  listItemText: {
    '&:focus': {
      backgroundColor: archerConstants.archerHover
    }
  },
  childListItemText: {
    padding: 0,
    '&:focus': {
      backgroundColor: archerConstants.archerHover
    }
  },
  childListItemTextNoSelect: {
    padding: 0
  },
  iconButton: {
    margin: 0,
    padding: 0,
    '& :hover svg, &:focus svg': {
      display: 'inline',
      color: customArcherColors.alertColors && customArcherColors.alertColors.error,
      '&:focus': {
        background: 'primary.main'
      },
      '& :focus > div > span': {
        color: 'text.primary'
      },
      outline: 'none',
      '& svg': {
        display: 'none'
      }
    },
    '& [class*="MuiSvgIcon-fontSizeSmall"]': {
      fontSize: '1rem'
    }
  },
  toolTip: {
    margin: 0,
    padding: 0
  },
  iconListItem: {
    justifyContent: 'flex-end',
    maxWidth: '3rem'
  },
  cascadeListItem: (_cascadeListItem = {
    width: 'auto',
    justifyContent: 'flex-end'
  }, _defineProperty(_cascadeListItem, "& .".concat(checkboxClasses['colorPrimary'], ".Mui-checked:hover"), {
    backgroundColor: 'transparent'
  }), _defineProperty(_cascadeListItem, "& .".concat(checkboxClasses['colorPrimary'], ":hover"), {
    backgroundColor: 'transparent'
  }), _defineProperty(_cascadeListItem, '& label', _defineProperty({
    marginRight: '0.7rem'
  }, "& .".concat(formControlLabelClasses['label']), {
    display: 'none'
  })), _cascadeListItem)
};

var RecursiveListItemBase = function RecursiveListItemBase(_ref) {
  var dataListItem = _ref.dataListItem,
      clickHandler = _ref.clickHandler,
      _ref$searchString = _ref.searchString,
      searchString = _ref$searchString === void 0 ? '' : _ref$searchString,
      disabled = _ref.disabled,
      selected = _ref.selected,
      showChildren = _ref.showChildren,
      parentSelectable = _ref.parentSelectable,
      expandChildClickHandler = _ref.expandChildClickHandler,
      isSelectedList = _ref.isSelectedList,
      forceShowRecursion = _ref.forceShowRecursion,
      doubleClickHandler = _ref.doubleClickHandler,
      toggleCascadeHandler = _ref.toggleCascadeHandler,
      toolTipExpand = _ref.toolTipExpand,
      toolTipCollapse = _ref.toolTipCollapse,
      toolTipCannotRemove = _ref.toolTipCannotRemove,
      toolTipRemove = _ref.toolTipRemove,
      textCascade = _ref.textCascade,
      sx = _ref.sx;
  var showParentAndExpand = false; // Test fpr SonarQube

  var listWithChildren = styles.listWithChildren,
      listItemRoot = styles.listItemRoot,
      listItemRootLabel = styles.listItemRootLabel,
      recursiveChildList = styles.recursiveChildList,
      childListItemExpander = styles.childListItemExpander,
      listItemText = styles.listItemText,
      childListItemText = styles.childListItemText,
      childListItemTextNoSelect = styles.childListItemTextNoSelect,
      toolTip = styles.toolTip,
      iconButton = styles.iconButton,
      iconListItem = styles.iconListItem,
      cascadeListItem = styles.cascadeListItem;

  var _React$useState = React.useState(showChildren || showParentAndExpand),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      toggleOpen = _React$useState2[1];

  var cascadeItemsGroup = {
    items: []
  }; // TODO: translate "cascade toggle" string

  if (isSelectedList && dataListItem.showCascade) {
    cascadeItemsGroup = {
      items: [{
        color: 'primary',
        description: "".concat(dataListItem.label).concat(textCascade ? " ".concat(textCascade) : ''),
        id: dataListItem.id,
        isChecked: dataListItem.cascade ? dataListItem.cascade : false,
        isEnabled: true
      }]
    };
  }

  if (isSelectedList && !dataListItem.selected && !forceShowRecursion) {
    return null;
  }

  var searchItem = function searchItem(listItem) {
    if (searchString ? searchString.length <= 0 : '') {
      return true;
    }

    if (listItem.children && listItem.children.some(function (child) {
      return child.label && child.label.toLowerCase().includes(searchString && searchString.length > 0 ? searchString : '');
    })) {
      showParentAndExpand = true;
      return true;
    }

    if (listItem.label.toLowerCase().includes(searchString)) {
      showParentAndExpand = true;
      return true;
    }

    showParentAndExpand = false;
    return false;
  };

  var searchChild = function searchChild(childItem) {
    if (childItem.label && childItem.label.toLowerCase().includes(searchString)) {
      return true;
    }

    return false;
  };

  var children = dataListItem.children;

  var handleItemClick = function handleItemClick(item) {
    if (clickHandler) {
      clickHandler(item);
    }
  };

  var handleItemDoubleClick = function handleItemDoubleClick(item) {
    if (doubleClickHandler) {
      doubleClickHandler(item);
    }
  };

  var handleKeyDown = function handleKeyDown(event, item) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      handleItemDoubleClick(item);
    }
  };

  var handleClickExpand = function handleClickExpand(item) {
    toggleOpen(!open);

    if (expandChildClickHandler) {
      expandChildClickHandler(item);
    }
  };

  var handleCascadeToggle = function handleCascadeToggle(item) {
    if (toggleCascadeHandler) {
      toggleCascadeHandler(item);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, searchItem(dataListItem) && /*#__PURE__*/React.createElement(ListItem, {
    key: dataListItem.id,
    id: "listitem-root-".concat(dataListItem.id),
    selected: selected,
    disabled: disabled,
    sx: [listItemRoot, sx],
    "aria-label": dataListItem.label
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "listitem-root-".concat(dataListItem.id),
    "aria-label": dataListItem.label
  }), children && children.length > 0 || dataListItem.expandable ? [/*#__PURE__*/React.createElement(List, {
    dense: true,
    key: dataListItem.id,
    sx: listWithChildren
  }, /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    onClick: function onClick() {
      return handleClickExpand(dataListItem);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e, dataListItem);
    },
    component: "li",
    sx: childListItemExpander,
    id: "expand-".concat(dataListItem.id),
    title: open ? "".concat(toolTipCollapse, " ").concat(dataListItem.label) : "".concat(toolTipExpand, " ").concat(dataListItem.label),
    "aria-label": open ? "".concat(toolTipCollapse, " ").concat(dataListItem.label) : "".concat(toolTipExpand, " ").concat(dataListItem.label)
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "expand-".concat(dataListItem.id),
    "aria-label": open ? "".concat(toolTipCollapse, " ").concat(dataListItem.label) : "".concat(toolTipExpand, " ").concat(dataListItem.label)
  }), !isSelectedList || forceShowRecursion ? /*#__PURE__*/React.createElement(Icon, {
    icon: open ? 'ArrowDropDown' : 'ArrowRight',
    fontSize: "small"
  }) : null), parentSelectable ? /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    onClick: function onClick() {
      return handleItemClick(dataListItem);
    },
    onDoubleClick: function onDoubleClick() {
      return handleItemDoubleClick(dataListItem);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e, dataListItem);
    },
    sx: dataListItem.deleteDisabled ? childListItemTextNoSelect : childListItemText,
    component: "li",
    id: "parent-selectable-".concat(dataListItem.id),
    tabIndex: dataListItem.deleteDisabled ? -1 : 0,
    "aria-label": dataListItem.label
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "parent-selectable-".concat(dataListItem.id),
    "aria-label": dataListItem.label
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, null, dataListItem.label)
  })) : /*#__PURE__*/React.createElement(ListItem, {
    sx: dataListItem.deleteDisabled ? childListItemTextNoSelect : childListItemText,
    id: dataListItem.id,
    "aria-label": dataListItem.label,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e, dataListItem);
    },
    tabIndex: dataListItem.deleteDisabled ? -1 : 0
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: dataListItem.id,
    "aria-label": dataListItem.label
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, null, dataListItem.label)
  })), isSelectedList && /*#__PURE__*/React.createElement(React.Fragment, null, dataListItem.showCascade && /*#__PURE__*/React.createElement(ListItem, {
    sx: cascadeListItem
  }, /*#__PURE__*/React.createElement(_DeprecatedCheckbox, {
    disableRipple: true,
    noFormControl: true,
    checkboxGroup: cascadeItemsGroup,
    checked: dataListItem.cascade,
    onChange: function onChange() {
      return handleCascadeToggle(dataListItem);
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    sx: iconListItem
  }, /*#__PURE__*/React.createElement(Tooltip, {
    sx: toolTip,
    title: dataListItem.deleteDisabled ? toolTipCannotRemove : toolTipRemove
  }, /*#__PURE__*/React.createElement(IconButton, {
    tabIndex: -1,
    fontSize: "medium",
    onClick: function onClick() {
      return handleItemDoubleClick(dataListItem);
    },
    icon: dataListItem.deleteDisabled ? 'NotInterested' : 'RemoveCircle',
    sx: iconButton
  })))))] : /*#__PURE__*/React.createElement(List, {
    dense: true,
    sx: [listItemRootLabel, sx]
  }, dataListItem.leftIcon && /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Icon, {
    icon: dataListItem.leftIcon,
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    component: "li",
    sx: listItemText,
    onClick: function onClick() {
      return handleItemClick(dataListItem);
    },
    onDoubleClick: function onDoubleClick() {
      return handleItemDoubleClick(dataListItem);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e, dataListItem);
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, {
      title: dataListItem.label
    }, dataListItem.label),
    disableTypography: true
  })), isSelectedList && /*#__PURE__*/React.createElement(React.Fragment, null, dataListItem.showCascade && /*#__PURE__*/React.createElement(ListItem, {
    sx: cascadeListItem
  }, /*#__PURE__*/React.createElement(_DeprecatedCheckbox, {
    disableRipple: true,
    noFormControl: true,
    checkboxGroup: cascadeItemsGroup,
    checked: dataListItem.cascade,
    onChange: function onChange() {
      return handleCascadeToggle(dataListItem);
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    sx: iconListItem
  }, /*#__PURE__*/React.createElement(Tooltip, {
    sx: toolTip,
    title: dataListItem.deleteDisabled ? toolTipCannotRemove : toolTipRemove
  }, /*#__PURE__*/React.createElement(IconButton, {
    tabIndex: -1,
    fontSize: "medium",
    onClick: function onClick() {
      return handleItemDoubleClick(dataListItem);
    },
    icon: dataListItem.deleteDisabled ? 'NotInterested' : 'RemoveCircle',
    sx: iconButton
  })))))), /*#__PURE__*/React.createElement(Collapse, {
    isOpen: open,
    timeout: "auto",
    unmountOnExit: true
  }, children && children.length > 0 && children.map(function (child) {
    return searchChild(child) && /*#__PURE__*/React.createElement(List, {
      dense: true,
      key: child.id,
      sx: recursiveChildList,
      role: "list"
    }, children.length > 0 ? /*#__PURE__*/React.createElement(RecursiveListItem, _extends({
      id: child.id,
      selected: child.selected,
      dataListItem: child
    }, child.tabFocus && {
      tabFocus: true
    }, {
      clickHandler: handleItemClick,
      doubleClickHandler: doubleClickHandler,
      expandChildClickHandler: expandChildClickHandler,
      key: child.id,
      label: child.label,
      searchString: child.searchString,
      showInnerChildren: false,
      showChildren: false,
      forceShowRecursion: forceShowRecursion,
      isSelectedList: isSelectedList,
      parentSelectable: parentSelectable,
      toggleCascadeHandler: handleCascadeToggle,
      toolTipExpand: toolTipExpand,
      toolTipCollapse: toolTipCollapse,
      toolTipCannotRemove: toolTipCannotRemove,
      toolTipRemove: toolTipRemove
    })) : null);
  })));
};

var RecursiveListItem = /*#__PURE__*/React.memo(RecursiveListItemBase);
RecursiveListItem.displayName = 'RecursiveListItem';
export { RecursiveListItem };